'use strict';
var customSwal = require('../utils/customSwal');

function priorBestPriceModal() {
	$(document).on('click', '.prior-best-price-icon', function (e) {
		e.preventDefault();
		e.stopPropagation();
		var triggerBtn = e.currentTarget;
		var panelRoot = document.getElementById(triggerBtn.getAttribute('aria-controls'));
		if (!panelRoot) {
			return;
		}
		var returnSlot = document.createElement('span');
		returnSlot.hidden = true;
		panelRoot.parentNode.insertBefore(returnSlot, panelRoot);
		panelRoot.hidden = false;

		var mobile = typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767.98px)').matches;

		var opts = {
			html: panelRoot,
			didOpen: function () {
				document.documentElement.classList.add('no-overflow');
				triggerBtn.setAttribute('aria-expanded', 'true');
			},
			didClose: function () {
				document.documentElement.classList.remove('no-overflow');
				if (returnSlot && returnSlot.parentNode && panelRoot) {
					panelRoot.hidden = true;
					returnSlot.parentNode.insertBefore(panelRoot, returnSlot);
					returnSlot.parentNode.removeChild(returnSlot);
				}
				triggerBtn.setAttribute('aria-expanded', 'false');
			},
			customClass: {
				container: 'sa-right-panel-container sa-prior-best-price',
				popup: 'sa-right-panel-popup sa-prior-best-price__popup',
				htmlContainer: 'sa-right-panel-html sa-prior-best-price__html'
			}
		};

		if (mobile) {
			Object.assign(opts, {
				position: 'bottom',
				grow: 'row',
				width: '100%',
				showClass: { popup: 'sa2-slide-up-in sa2-anim-faster' },
				hideClass: { popup: 'sa2-slide-down-out sa2-anim-faster' }
			});
		}

		customSwal.Swal.fire(customSwal.rightPanelOptions(opts));
	});
}

module.exports = function initPriorBestPrice() {
	priorBestPriceModal();
};

module.exports.priorBestPriceModal = priorBestPriceModal;
